import { SxProps, Theme } from "@mui/material";

export const containerSx: SxProps<Theme> = {
  py: 2,
};

export const inputContainerSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 2,
};

export const associatedModelSectionSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 3,
  mt: 3,
};

export const sectionTitleSx: SxProps<Theme> = {
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "20px",
  m: 0,
};

export const sectionDescriptionSx: SxProps<Theme> = {
  fontSize: "16px",
  lineHeight: "22px",
  m: 0,
};

export const dropdownArrowSx: SxProps<Theme> = {
  width: 48,
  height: 48,
  top: "7px !important",
};

export const vehicleSelectMenuProps = {
  sx: { "& .MuiPopover-paper": { maxHeight: 200 } },
} as const;
